export const updateAccessStatus = data => {
  return {
    type: "UPDATE_ACCESS_STATUS",
    data
  };
};

export const resetState = () => {
  return {
    type: "RESET_STATE",
  };
};

export const updateUser = data => {
  return {
    type: "UPDATE_USER",
    data
  };
};

export const updateProjects = data => {
  return {
    type: "UPDATE_PROJECTS",
    data
  };
};

export const updatePlan = data => {
  return {
    type: "UPDATE_PLAN",
    data
  };
};

export const updatePlans = data => {
    return {
        type: "UPDATE_PLANS",
        data
    };
};

export const updateSending = data => {
  return {
    type: "UPDATE_SENDING",
    data
  };
};

export const updateDeleting = data => {
  return {
    type: "UPDATE_DELETING",
    data
  };
};

export const updateInitApp = data => {
  return {
    type: "UPDATE_INIT_APP",
    data
  };
};

export const showNotify = data => {
  return {
    type: "SHOW_NOTIFY",
    data
  };
};

export const hideNotify = data => {
  return {
    type: "HIDE_NOTIFY",
    data
  };
};